import * as yup from 'yup'
import { api } from '../services/api'
import { cacheAsyncValidation } from '../utils/forms'

export default yup.object().shape(
  {
    name: yup.string().required('Campo obrigatório'),
    email: yup
      .string()
      .email('Campo precisa ser um email')
      .when('email', {
        is: (email: string) => {
          const pattern = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i
          return pattern.test(email)
        },
        then: yup.string().test(
          'email-validation',
          'E-mail já em uso',
          cacheAsyncValidation(async (email: string) => {
            const emailInLowerCase = email.toLowerCase()
            const { data: isEmailAvailable } = await api.get<boolean>(
              `/users/email-available/${emailInLowerCase}`
            )
            return !isEmailAvailable
          })
        ),
      })
      .required('Campo obrigatório'),
  },
  [['email', 'email']]
)
